import { RootState } from 'rootReducer';

export const selectIsPostingLinkedInAuth = (state: RootState) =>
  state.ui.apps.survey.linkedIn.isPostingLinedInAuth;

export const selectSuccessRedirectUrl = (state: RootState) =>
  state.ui.apps.survey.linkedIn.redirect_to;
